import React, { useState, useRef, useEffect } from "react";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import './cadastro.css';
import api from "../../Services/api";
import InputMask from 'react-input-mask';
import { currentConfig } from "../../Services/config";
import { injectDynamicStyles } from "../../Services/dynamicStyles";

export const Cadastro = () => {
    const [nome, setNome] = useState("");
    const [datanascimento, setDatanascimento] = useState("");
    const [telefone, setTelefone] = useState("");
    const [email, setEmail] = useState("");
    const [disabled, setDisabled] = useState(false);
    const [cidade, setCidade] = useState("");
    const [estado, setEstado] = useState("");
    const [nomeContatoEmerg, setNomeContatoEmerg] = useState("");
    const [contatoEmerg, setContatoEmerg] = useState("");
    const [pergunta1, setPergunta1] = useState(null); // Problemas cardíacos?
    const [pergunta2, setPergunta2] = useState(null); // Gestante?
    const [pergunta3, setPergunta3] = useState(null); // Dificuldades respiratórias ou asma?
    const [pergunta4, setPergunta4] = useState(null); // Desmaios, epilepsia e/ou convulsões?
    const [pergunta5, setPergunta5] = useState(null); // Em período pós-operatório?
    const [pergunta6, setPergunta6] = useState(null); // Problemas ósseos e/ou na coluna vertebral?
    const [pergunta7, setPergunta7] = useState(null); // Estar sob efeito de álcool e/ou entorpecentes?
    const [pergunta8, setPergunta8] = useState(null); // Possui fobia de altura?
    // const [comoConheceu, setComoConheceu] = useState(""); // Como nos conheceu?
    const [termoAceito, setTermoAceito] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const modalRef = useRef(null);
    
    const [documentoTipo, setDocumentoTipo] = useState("CPF"); // "CPF" ou "Passaporte"
    const [documento, setDocumento] = useState("");

    const getMask = () => (documentoTipo === "CPF" ? "999.999.999-99" : "");

    const handleDocumentoTipoChange = (event, newTipo) => {
        if (newTipo !== null) {
          setDocumentoTipo(newTipo);
          setDocumento("");
        }
      };

    const handleInputChange = (e) => {
        let value = e.target.value;
        
        if (documentoTipo === "CPF") {
          value = value.replace(/\D/g, ""); 
        } else {
          value = value.toUpperCase();
        }
    
        setDocumento(value);
      };

    const SendEmail = (e) => {
        e.preventDefault();
        setDisabled(true);
        ValidaCadastro();
    }

    const LimparCampos = () => {
        setNome('');
        setDatanascimento('');
        setDocumento('');
        setTelefone('');
        setEmail('');
        setCidade('');
        setEstado('');
        setNomeContatoEmerg('');
        setContatoEmerg('');
        setPergunta1(null);
        setPergunta2(null);
        setPergunta3(null);
        setPergunta4(null);
        setPergunta5(null);
        setPergunta6(null);
        setPergunta7(null);
        setPergunta8(null);
        // setComoConheceu('');
        setTermoAceito(false);
    }

    function validateFields() {
        if (documentoTipo === "CPF" && !isValidCPF(documento)) {
            alert("Por favor, insira um CPF válido com 11 dígitos.");
        return false;
        }

        const basicFieldsValid = nome && datanascimento && documento && telefone && email && cidade && estado && termoAceito;

        // Contato de emergência e perguntas de saúde só são obrigatórios quando o tenant os exibe
        const emergencyContactValid = !currentConfig.showEmergencyContact || (nomeContatoEmerg && contatoEmerg);
        const healthQuestionsValid = !currentConfig.showHealthQuestions ||
            (pergunta1 && pergunta2 && pergunta3 && pergunta4 && pergunta5 && pergunta6 && pergunta7 && pergunta8);

        return basicFieldsValid && emergencyContactValid && healthQuestionsValid;
    }
    
    const isValidCPF = (cpf) => {
        return cpf.length === 11;
    };

    async function ValidaCadastro() {
        if (validateFields()) {
            api.defaults.headers.post = { 'Content-Type': 'application/json' };
            api.defaults.headers.post = { "Content-Type": 'multipart/form-data' };
            let cadastro = await EnviaCadastro();

            if (cadastro.status === 200) {
                alert('Cadastro efetuado com sucesso!');
                LimparCampos();
                setDisabled(false);
                window.location.href = `/QrCodePage/${cadastro.data.id}`;
            } else {
                alert('Falha ao Cadastrar');
                setDisabled(false);
            }
        } else {
            alert('Atenção! Preencha todos os campos e aceite os termos de uso.');
            setDisabled(false);
        }
    }

    async function EnviaCadastro() {
        const dadosBasicos = {
            'nome': nome,
            'datanascimento': datanascimento.split('/')[2] + '-' + datanascimento.split('/')[1] + '-' + datanascimento.split('/')[0],
            'cpf': documento,
            'telefone': telefone,
            'email': email,
            'cidade': cidade,
            'estado': estado,
            'comoConheceu': '',
            'situacao': 0,
            'atividade': 0,
        };

        if (currentConfig.showEmergencyContact) {
            dadosBasicos.nomeContatoEmerg = nomeContatoEmerg;
            dadosBasicos.contatoEmerg = contatoEmerg;
        }

        if (currentConfig.showHealthQuestions) {
            dadosBasicos.pergunta1 = pergunta1;
            dadosBasicos.pergunta2 = pergunta2;
            dadosBasicos.pergunta3 = pergunta3;
            dadosBasicos.pergunta4 = pergunta4;
            dadosBasicos.pergunta5 = pergunta5;
            dadosBasicos.pergunta6 = pergunta6;
            dadosBasicos.pergunta7 = pergunta7;
            dadosBasicos.pergunta8 = pergunta8;
        }

        let response = await api.post('pessoa/cadastro', dadosBasicos);
        return response;
    }

    const openModal = () => {
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
    };

    const handleTermoChange = (e) => {
        setTermoAceito(e.target.checked);
    };

    // Função para fechar o modal ao clicar fora dele
    const handleClickOutside = (event) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
            closeModal();
        }
    };

    useEffect(() => {
        // Injeta os estilos dinâmicos baseados na configuração atual
        injectDynamicStyles();
        
        // Adiciona o listener de clique ao montar o componente
        document.addEventListener("mousedown", handleClickOutside);
        // Remove o listener ao desmontar o componente
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
        // eslint-disable-next-line
    }, []);

    return (
        <>
            <main className="fundo">
                <div className="logo">
                    <img src={currentConfig.logo} alt="" />
                </div>

                <form className="form" onSubmit={SendEmail}>
                    <h1>Formulário</h1>

                    <input
                        type="text"
                        name="nome"
                        className="input"
                        placeholder="Nome / Name"
                        onChange={(e) => { setNome(e.target.value) }}
                        value={nome}
                        maxLength={100}
                    />
                    <InputMask
                        mask="99/99/9999"
                        className="input"
                        placeholder="Data Nascimento / Birth Date Day/Mouth/Year"
                        type="tel"
                        name="datanascimento"
                        onChange={(e) => { setDatanascimento(e.target.value); }}
                        value={datanascimento}
                    />

              
                    {/* Switch para CPF e Passaporte */}
                    <ToggleButtonGroup
                        value={documentoTipo}
                        exclusive
                        onChange={handleDocumentoTipoChange}
                        aria-label="Tipo de Documento"
                        style={{ marginLeft:30 }}
                    >
                        <ToggleButton 
                            value="CPF" 
                            aria-label="CPF"
                            sx={{
                                "&.Mui-selected": {
                                backgroundColor: "#A7EB93",
                                color: "#fff",
                                "&:hover": {
                                    backgroundColor: "#8FD97A",
                                },
                                },
                                borderRadius: "20px",
                                border: "1px solid #A7EB93",
                                textTransform: "none",
                                fontWeight: "bold",
                                padding: "10px 20px",
                            }}
                        >
                        CPF
                        </ToggleButton>
                        <ToggleButton 
                            value="Passaporte" 
                            aria-label="Passaporte"
                            sx={{
                                "&.Mui-selected": {
                                    backgroundColor: "#A7EB93",
                                    color: "#fff",
                                    "&:hover": {
                                    backgroundColor: "#8FD97A",
                                    },
                                },
                                borderRadius: "20px",
                                border: "1px solid #A7EB93",
                                textTransform: "none",
                                fontWeight: "bold",
                                padding: "10px 20px",
                            }}
                        >
                        Passaporte
                        </ToggleButton>
                    </ToggleButtonGroup>

                    <InputMask
                        mask={getMask()}
                        value={documento}
                        onChange={handleInputChange}
                        placeholder={documentoTipo === "CPF" ? "Digite seu CPF" : "Digite seu Passaporte"}
                        className="input"
                    />

                    <InputMask
                        className="input"
                        type="tel"
                        name="telefone"
                        placeholder="Celular / Phone Number"
                        onChange={(e) => {
                            setTelefone(e.target.value.replace(/\D/g, ''))
                        }}
                        value={telefone}
                    />

                    <input
                        type="email"
                        className="input"
                        name="destinatarioemail"
                        placeholder="Email"
                        onChange={(e) => { setEmail(e.target.value); }} value={email}
                    />

                    <input
                        type="text"
                        name="cidade"
                        className="input"
                        placeholder="Cidade / Country"
                        onChange={(e) => { setCidade(e.target.value) }}
                        value={cidade}
                        maxLength={100}
                    />

                    <input
                        type="text"
                        name="estado"
                        className="input"
                        placeholder="UF / State"
                        onChange={(e) => { setEstado(e.target.value.toUpperCase()) }}
                        value={estado}
                        maxLength={2}
                    />

                    {/* Campo Como nos conheceu */}
                    {/* <select
                        name="comoConheceu"
                        className="input select-como-conheceu"
                        value={comoConheceu}
                        onChange={(e) => { setComoConheceu(e.target.value) }}
                    >
                        <option value="">Conte pra nós como nos conheceu?</option>
                        <option value="Indicação Hospedagem">Indicação Hospedagem</option>
                        <option value="Indicação Restaurante">Indicação Restaurante</option>
                        <option value="Indicação Marinheiro">Indicação Marinheiro</option>
                        <option value="Ponto de Apoio CENTRO">Ponto de Apoio CENTRO</option>
                        <option value="Google">Google</option>
                        <option value="Instagram">Instagram</option>
                        <option value="TikTok">TikTok</option>
                        <option value="YouTube">YouTube</option>
                        <option value="Indicação de um parente">Indicação de um parente</option>
                        <option value="Outros">Outros</option>
                    </select> */}

                    {currentConfig.showEmergencyContact && (
                        <div className="contato-emergencia">
                            <h3 style={{marginLeft:30}}>Contato de Emergência</h3>
                            <input
                                type="text"
                                name="nomeContatoEmerg"
                                className="input"
                                placeholder="Nome / Name"
                                onChange={(e) => { setNomeContatoEmerg(e.target.value) }}
                                value={nomeContatoEmerg}
                                maxLength={100}
                            />
                            <InputMask
                                className="input"
                                type="tel"
                                name="contatoEmerg"
                                placeholder="Telefone / Phone Number"
                                onChange={(e) => {
                                setContatoEmerg(e.target.value.replace(/\D/g, ''))
                                }}
                                value={contatoEmerg}
                            />
                        </div>
                    )}

                    {currentConfig.showHealthQuestions && (
                        <>
                            <div className="pergunta">
                        <label>Problemas cardíacos?</label>
                        <div className="radio-group">
                            <label className="resposta">
                                <input
                                    type="radio"
                                    name="pergunta1"
                                    value="Sim"
                                    onChange={(e) => setPergunta1('1')}
                                    checked={pergunta1 === '1'}
                                />
                                Sim
                            </label>
                            <label className="resposta">
                                <input
                                    type="radio"
                                    name="pergunta1"
                                    value="Não"
                                    onChange={(e) => setPergunta1('0')}
                                    checked={pergunta1 === '0'}
                                />
                                Não
                            </label>
                        </div>
                    </div>

                    <div className="pergunta">
                        <label>Gestante?</label>
                        <div className="radio-group">
                            <label className="resposta">
                                <input
                                    type="radio"
                                    name="pergunta2"
                                    value="Sim"
                                    onChange={(e) => setPergunta2('1')}
                                    checked={pergunta2 === '1'}
                                />
                                Sim
                            </label>
                            <label className="resposta">
                                <input
                                    type="radio"
                                    name="pergunta2"
                                    value="Não"
                                    onChange={(e) => setPergunta2('0')}
                                    checked={pergunta2 === '0'}
                                />
                                Não
                            </label>
                        </div>
                    </div>

                    <div className="pergunta">
                        <label>Dificuldades respiratórias ou asma?</label>
                        <div className="radio-group">
                            <label className="resposta">
                                <input
                                    type="radio"
                                    name="pergunta3"
                                    value="Sim"
                                    onChange={(e) => setPergunta3('1')}
                                    checked={pergunta3 === '1'}
                                />
                                Sim
                            </label>
                            <label className="resposta">
                                <input
                                    type="radio"
                                    name="pergunta3"
                                    value="Não"
                                    onChange={(e) => setPergunta3('0')}
                                    checked={pergunta3 === '0'}
                                />
                                Não
                            </label>
                        </div>
                    </div>

                    <div className="pergunta">
                        <label>Desmaios, epilepsia e/ou convulsões?</label>
                        <div className="radio-group">
                            <label className="resposta">
                                <input
                                    type="radio"
                                    name="pergunta4"
                                    value="Sim"
                                    onChange={(e) => setPergunta4('1')}
                                    checked={pergunta4 === '1'}
                                />
                                Sim
                            </label>
                            <label className="resposta">
                                <input
                                    type="radio"
                                    name="pergunta4"
                                    value="Não"
                                    onChange={(e) => setPergunta4('0')}
                                    checked={pergunta4 === '0'}
                                />
                                Não
                            </label>
                        </div>
                    </div>

                    <div className="pergunta">
                        <label>Em período pós-operatório?</label>
                        <div className="radio-group">
                            <label className="resposta">
                                <input
                                    type="radio"
                                    name="pergunta5"
                                    value="Sim"
                                    onChange={(e) => setPergunta5('1')}
                                    checked={pergunta5 === '1'}
                                />
                                Sim
                            </label>
                            <label className="resposta">
                                <input
                                    type="radio"
                                    name="pergunta5"
                                    value="Não"
                                    onChange={(e) => setPergunta5('0')}
                                    checked={pergunta5 === '0'}
                                />
                                Não
                            </label>
                        </div>
                    </div>

                    <div className="pergunta">
                        <label>Problemas ósseos e/ou na coluna vertebral?</label>
                        <div className="radio-group">
                            <label className="resposta">
                                <input
                                    type="radio"
                                    name="pergunta6"
                                    value="Sim"
                                    onChange={(e) => setPergunta6('1')}
                                    checked={pergunta6 === '1'}
                                />
                                Sim
                            </label>
                            <label className="resposta">
                                <input
                                    type="radio"
                                    name="pergunta6"
                                    value="Não"
                                    onChange={(e) => setPergunta6('0')}
                                    checked={pergunta6 === '0'}
                                />
                                Não
                            </label>
                        </div>
                    </div>

                    <div className="pergunta">
                        <label>Estar sob efeito de álcool e/ou entorpecentes?</label>
                        <div className="radio-group">
                            <label className="resposta">
                                <input
                                    type="radio"
                                    name="pergunta7"
                                    value="Sim"
                                    onChange={(e) => setPergunta7('1')}
                                    checked={pergunta7 === '1'}
                                />
                                Sim
                            </label>
                            <label className="resposta">
                                <input
                                    type="radio"
                                    name="pergunta7"
                                    value="Não"
                                    onChange={(e) => setPergunta7('0')}
                                    checked={pergunta7 === '0'}
                                />
                                Não
                            </label>
                        </div>
                    </div>

                    <div className="pergunta">
                        <label>Possui fobia de altura?</label>
                        <div className="radio-group">
                            <label className="resposta">
                                <input
                                    type="radio"
                                    name="pergunta8"
                                    value="Sim"
                                    onChange={(e) => setPergunta8('1')}
                                    checked={pergunta8 === '1'}
                                />
                                Sim
                            </label>
                            <label className="resposta">
                                <input
                                    type="radio"
                                    name="pergunta8"
                                    value="Não"
                                    onChange={(e) => setPergunta8('0')}
                                    checked={pergunta8 === '0'}
                                />
                                Não
                            </label>
                        </div>
                    </div>
                        </>
                    )}

                    <div className="termos-uso">
                        <label>
                            <input
                                type="checkbox"
                                checked={termoAceito}
                                onChange={handleTermoChange}
                            />
                            Aceito os <button type="button" onClick={openModal}>Termos de Uso</button>
                        </label>
                    </div>

                    <input disabled={disabled || !termoAceito} type="submit" className="inputSubmit" value="ENVIAR" />
                </form>

                {showModal && (
                    <div className="modal" onClick={handleClickOutside}>
                        <div className="modal-content" ref={modalRef}>
                            <span className="close" onClick={closeModal}>&times;</span>
                            <h2>Termos de Uso</h2>
                            <br /><br />
                            <p dangerouslySetInnerHTML={{ __html: currentConfig.termosUso }} />
                            <button type="button" className="inputClose" onClick={closeModal}>Fechar</button>
                        </div>
                    </div>
                )}

                <div style={{ textAlign: "center", marginTop: "20px", fontSize: "14px", color: "#555", marginBottom: "20px" }}>
                    Desenvolvido por 
                    <a 
                        href="https://wa.me/5535991732995?text=Olá,%20queria%20saber%20mais%20sobre%20%20oRoteiro%20Seguro" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        style={{ color: "#007bff", textDecoration: "none", marginLeft: "5px" }}
                    >
                        Roteiro Seguro
                    </a>
                </div>
            </main>
        </>
    )
}